/**
 * Sender display helpers for the mail catcher's initials avatars. Reuses the
 * chat's `initials` / `avatarColor` (components/chatHelpers.js) so a sender
 * avatar looks like every other avatar in the app — the colour is a hash of
 * the ADDRESS, so the same sender is always the same colour.
 */
import { initials, avatarColor } from '../chatHelpers';

/** `"Alice Example <alice@x>"` → `{ name: 'Alice Example', address: 'alice@x' }`. */
export function parseSender(display) {
  const s = String(display || '').trim();
  const m = /^"?([^"<]*?)"?\s*<([^>]*)>$/.exec(s);
  if (m) return { name: m[1].trim(), address: m[2].trim() };
  return { name: '', address: s };
}

/** The bold line of a list row: the display name, else the address. */
export function senderName(display) {
  const { name, address } = parseSender(display);
  return name || address || '?';
}

/** The address line under the name (empty when the sender is address-only). */
export function senderAddress(display) {
  const { name, address } = parseSender(display);
  return name ? address : '';
}

/** Initials: from the name when there is one, else from the local part. */
export function senderInitials(display) {
  const { name, address } = parseSender(display);
  if (name) return initials(name);
  const local = (address.split('@')[0] || '').replace(/[._+-]+/g, ' ').trim();
  return initials(local || address || '?');
}

export function senderColor(display) {
  const { name, address } = parseSender(display);
  return avatarColor((address || name).toLowerCase());
}
